<div class="mainwrapper mysteryschool_signupmainwrapper">
   
        <div class="new-container">
            <mat-card class="main-title">
                <h2>Sign Up for Mystery School</h2>
            </mat-card>
            <div class="subwrapper">
                <div class="formStyle user-form">
                    <mat-card-content class="addEditPageWrapper practice_form_style form_title_style">
                        
                        <div class="AddEditBlog taxonomies_formstyle">
                            <div class="addEditForm calendarofeventsForm">
                                <lib-showform [formdata]="configFormData" [formfieldrefresh]="formfieldrefresh"
                                    [formfieldrefreshdata]="formfieldrefreshdata"
                                    (onFormFieldChange)="listenFormFieldChange($event)">
                                </lib-showform>

                                <ng-container *ngIf="formLoader">
                                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                </ng-container>
                                
                            </div>
                        </div>

                    </mat-card-content>

                </div>
            </div>
        </div>
   
</div>
